export const SET_LOADING_RENOV_DOC = "SET_LOADING_RENOV_DOC";
export const SET_DOCUMENTOS_RENOV_DOC = "SET_DOCUMENTOS_RENOV_DOC";
export const SET_TIPOS_DOCUMENTOS_RENOV_DOC = "SET_TIPOS_DOCUMENTOS_RENOV_DOC";
export const SET_TIPO_PESSOA = "SET_TIPO_PESSOA";
export const ADD_INPUT_LOADING = "ADD_INPUT_LOADING";
export const REMOVE_INPUT_LOADING = "REMOVE_INPUT_LOADING";
export const SET_TIPOS_DOC_OBRIGATORIOS_OPCIONAIS = 'SET_TIPOS_DOC_OBRIGATORIOS_OPCIONAIS';








